import { ICardDescriptionHeader } from "../../types/header-card-type";
import WeatherWithIcon from "@/components/weather-with-icon/WeatherWithIcon";
import { formatWeatherStateIcon } from "@/helpers/format-weather-state-icon";

import "./style.scss";

type PrevisionDescriptionCardHeaderProps = {
	data: ICardDescriptionHeader;
	isActive: boolean;
	handleClick: () => void;
};

export const PrevisionDescriptionCardHeader = ({
	data,
	isActive,
	handleClick,
}: PrevisionDescriptionCardHeaderProps) => {
	const dayFormatted = isActive ? data.day : `${data.day.slice(0, 3)}.`;

	const weatherIcon = data?.date
		? formatWeatherStateIcon({
				timeStep: data?.date.toISOString(),
				status: data?.ww,
		  })
		: undefined;

	return (
		<div className="prevision-description-card" onClick={() => handleClick()}>
			<div className={`content ${isActive ? "active-card" : ""}`}>
				<div className="date-header">
					<p>{dayFormatted}</p>
					<p>{data.dayWeek}</p>
				</div>

				{isActive && (
					<>
						<WeatherWithIcon
							type="weather"
							tempMax={data.tempMax}
							tempMin={data.tempMin}
							icon={
								weatherIcon ? (
									<img
										src={weatherIcon}
										className="icon-weather-card"
										alt="icon weather"
									/>
								) : undefined
							}
						/>
					</>
				)}

				{isActive && <div className="bar"></div>}
			</div>
		</div>
	);
};

export default PrevisionDescriptionCardHeader;
